import { push, replace, go, goBack, goForward } from 'react-router-redux'
import {
  actionTypes,
  arrayInsert,
  arrayMove,
  arrayPop,
  arrayPush,
  arrayRemove,
  arrayRemoveAll,
  arrayShift,
  arraySplice,
  arraySwap,
  arrayUnshift,
  autofill,
  blur,
  change,
  clearAsyncError,
  clearSubmitErrors,
  clearFields,
  destroy,
  focus,
  initialize,
  registerField,
  reset,
  resetSection,
  setSubmitFailed,
  setSubmitSucceeded,
  startAsyncValidation,
  startSubmit,
  stopSubmit,
  stopAsyncValidation,
  submit,
  touch,
  unregisterField,
  untouch
} from 'redux-form'

export const hasString = str => typeof str === 'string' && str.length > 0
export const hasArray = arr => Array.isArray(arr) && arr.length > 0
export function getActionCreators () {
  return {
    form: {
      changeMeta (form, field, payload = {}) {
        return {
          type: `${actionTypes.prefix}META`,
          meta: {
            form,
            field
          },
          payload
        }
      },
      arrayInsert,
      arrayMove,
      arrayPop,
      arrayPush,
      arrayRemove,
      arrayRemoveAll,
      arrayShift,
      arraySplice,
      arraySwap,
      arrayUnshift,
      autofill,
      blur,
      change,
      clearAsyncError,
      clearSubmitErrors,
      clearFields,
      destroy,
      focus,
      initialize,
      registerField,
      reset,
      resetSection,
      setSubmitFailed,
      setSubmitSucceeded,
      startAsyncValidation,
      startSubmit,
      stopSubmit,
      stopAsyncValidation,
      submit,
      touch,
      unregisterField,
      untouch
    },
    location: {
      push,
      replace,
      go,
      goBack,
      goForward
    }
  }
}
